export default {
  data() {
    return {
      /**全病程订单 */
      tabListL1Config: [
        {
          label: '序号',
          align: 'center',
          fixed: 'left',
          prop: 'date',
          size: 'mini',
          width: '50px',
          render: (h, scope) => {
            return <span slot="reference">{scope.$index * 1 + 1}</span>
          },
        },
        {
          label: '订单编号',
          align: 'center',
          prop: 'orderNo',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '服务名称',
          align: 'center',
          prop: 'serviceName',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '服务类型',
          align: 'center',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">
              {
                scope.row.type == 1 ? '医生服务' : scope.row.type == 2 ? '疗管服务' : '--'
              }
            </span>
          },
        },
        {
          label: '病人',
          align: 'center',
          prop: 'patientName',
          width: '120px',
          render: (h, scope) => {
            return <span slot="reference">{!scope.row.logOff ? scope.row.patientName : scope.row.patientName + '(已注销)'} </span>
          },
        },
        {
          label: '医生团队',
          align: 'center',
          prop: "doctorTeamName",
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '线下机构',
          align: 'center',
          prop: 'hospitalName',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '互医机构',
          align: 'center',
          prop: 'platformName',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '服务价格',
          align: 'center',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">
              {
                scope.row.specOriginalPrice
              }
            </span>
          },
        },
        {
          label: '优惠',
          align: 'center',
          prop: 'discount',
          size: 'mini',
          // render: (h, scope) => {
          //   return <span slot="reference">
          //     {
          //       scope.row.specOriginalPrice - scope.row.specCurrentPrice
          //     }
          //   </span>
          // },
        },
        {
          label: '实付金额',
          align: 'center',
          prop: 'specCurrentPrice',
          size: 'mini',
        },
        {
          label: '创建时间',
          align: 'center',
          prop: 'createTime',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '支付方式',
          align: 'center',
          prop: 'paymentMethid',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">
              {
                scope.row.commodityType === 6 && scope.row.specCurrentPrice === 0 ? "商品赠送" : this.handelPay(scope.row.paymentMethid)
              }
            </span>
          },
        },
        {
          label: '商户订单号',
          align: 'center',
          prop: 'transactionNo',
          size: 'mini',
          width: "100px",
          showOverflowTooltip: true,
          render: (h, scope) => {
            return <span slot="reference">
              {scope.row.transactionNo ? scope.row.transactionNo : '--'}
            </span>
          },
        },
        {
          label: '支付时间',
          align: 'center',
          prop: 'payTime',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '退款人',
          align: 'center',
          size: 'mini',
          showOverflowTooltip: true,
          render: (h, scope) => {
            return <span slot="reference">
              {scope.row.paymentState == 4 ? scope.row.refundUserName : ''}
            </span>
          },
        },
        {
          label: '退款金额',
          align: 'center',
          size: 'mini',
          prop: 'refundMoney'
        },
        {
          label: '退款备注',
          align: 'center',
          size: 'mini',
          prop: 'refundText',
          showOverflowTooltip: true
        },
        {
          label: '退款时间',
          align: 'center',
          prop: 'refundTime',
          size: 'mini',
          showOverflowTooltip: true
        },
        // {
        //     label:'平台分成',
        //     align :'center',
        //     size:'mini',
        //     render: (h, scope) => {
        //       return <span>-</span>
        //     },
        // },
        // {
        //     label:'医生酬金',
        //     align :'center',
        //     size:'mini',
        //     render: (h, scope) => {
        //       return <span>-</span>
        //     },
        // },
        {
          label: '订单状态',
          align: 'center',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">
              {
                scope.row.paymentState == 1 ? '待支付' :
                  scope.row.paymentState == 2 ? '已支付' :
                    scope.row.paymentState == 3 ? '已取消' :
                      scope.row.paymentState == 4 ? '已退款' :
                        scope.row.paymentState == 7 ? '已完成' :
                          scope.row.paymentState == 8 ? '待退款' :
                            '未知'
              }
            </span>
          },
        },
        {
          label: '是否组合订单',// 是组合订单 订单类型是6 服务金额为0 支付方式为商品推送
          align: 'center',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">
              {
                scope.row.commodityType == 6 ? '是' : '否'
              }
            </span>
          },
        },
        {
          label: '操作',
          align: 'center',
          fixed: "right",
          width: '150px',
          style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          render: (h, scope) => {
            return h('div', [
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  on: {
                    click: () => {
                      this.hometHandel(scope, 'details')
                    },
                  },
                },
                '详情'
              ),
              // h(
              //   'el-button',
              //   {
              //     props: { type: 'text', size: 'mini' },
              //     attrs: {
              //       disabled: scope.row.paymentState != 1 ? true : false,
              //     },
              //     on: {
              //       click: () => {
              //         this.reminderHandel(scope.row)
              //       },
              //     },
              //   },
              //   '提醒'
              // ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  attrs: {
                    disabled: (scope.row.paymentState == 2 || scope.row.paymentState == 8) ? false : true,
                  },
                  on: {
                    click: () => {
                      this.hometRefundHandel(scope.row)
                    },
                  },
                },
                scope.row.payAmount == 0 || (scope.row.commodityType === 6 && scope.row.specCurrentPrice === 0) ? '' : scope.row.paymentState == 4 ? '已退款' : '退款'

              ),
            ])
          },
        },
      ],
      tabListL2Config: [
        {
          label: '序号',
          align: 'center',
          fixed: 'left',
          prop: 'date',
          size: 'mini',
          width: '50px',
          render: (h, scope) => {
            return <span slot="reference">{scope.$index * 1 + 1}</span>
          },
        },
        {
          label: '订单编号',
          align: 'center',
          prop: 'orderNo',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '服务名称',
          align: 'center',
          prop: 'serviceName',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '服务类型',
          align: 'center',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">
              {
                scope.row.type == 1 ? '医生服务' : scope.row.type == 2 ? '疗管服务' : '--'
              }
            </span>
          },
        },
        {
          label: '病人',
          align: 'center',
          prop: 'patientName',
          width: '120px',
          render: (h, scope) => {
            return <span slot="reference">{!scope.row.logOff ? scope.row.patientName : scope.row.patientName + '(已注销)'} </span>
          },
        },
        {
          label: '医生团队',
          align: 'center',
          prop: "doctorTeamName",
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '互医机构',
          align: 'center',
          prop: 'platformName',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '服务价格',
          align: 'center',
          prop: 'amountOriginal',
          size: 'mini',
        },
        {
          label: '优惠',
          align: 'center',
          prop: 'discount',
          size: 'mini',
        },
        {
          label: '实付金额',
          align: 'center',
          prop: 'payAmount',
          size: 'mini',
        },
        {
          label: '创建时间',
          align: 'center',
          prop: 'createTime',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '支付方式',
          align: 'center',
          prop: 'paymentMethid',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">
              {
                scope.row.commodityType === 6 && scope.row.specCurrentPrice === 0 ? "商品赠送" : this.handelPay(scope.row.paymentMethid)
              }
            </span>
          },
        },
        {
          label: '商户订单号',
          align: 'center',
          prop: 'transactionNo',
          size: 'mini',
          width: "100px",
          showOverflowTooltip: true,
          render: (h, scope) => {
            return <span slot="reference">
              {scope.row.transactionNo ? scope.row.transactionNo : '--'}
            </span>
          },
        },
        {
          label: '支付时间',
          align: 'center',
          prop: 'payTime',
          size: 'mini',
          showOverflowTooltip: true
        },
        {
          label: '退款人',
          align: 'center',
          size: 'mini',
          showOverflowTooltip: true,

          render: (h, scope) => {
            return <span slot="reference">
              {scope.row.paymentState == 4 ? scope.row.refundUserName : ''}
            </span>
          },
        },
        {
          label: '退款金额',
          align: 'center',
          size: 'mini',
          prop: 'refundMoney'
        },
        {
          label: '退款备注',
          align: 'center',
          size: 'mini',
          prop: 'refundText',
          showOverflowTooltip: true
        },
        {
          label: '退款时间',
          align: 'center',
          prop: 'refundTime',
          size: 'mini',
          showOverflowTooltip: true
        },
        // {
        //     label:'平台分成',
        //     align :'center',
        //     size:'mini',
        //     render: (h, scope) => {
        //       return <span>-</span>
        //     },
        // },
        // {
        //     label:'医生酬金',
        //     align :'center',
        //     size:'mini',
        //     render: (h, scope) => {
        //       return <span>-</span>
        //     },
        // },
        {
          label: '订单状态',
          align: 'center',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">
              {
                scope.row.paymentState == 1 ? '待支付' :
                  scope.row.paymentState == 2 ? '已支付' :
                    scope.row.paymentState == 3 ? '已取消' :
                      scope.row.paymentState == 4 ? '已退款' :
                        scope.row.paymentState == 7 ? '已完成' :
                          scope.row.paymentState == 8 ? '待退款' :
                            '未知'
              }
            </span>
          },
        },
        {
          label: '是否组合订单',// 是组合订单 订单类型是6 服务金额为0 支付方式为商品推送
          align: 'center',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">
              {
                scope.row.commodityType == 6 ? '是' : '否'
              }
            </span>
          },
        },
        {
          label: '操作',
          align: 'center',
          fixed: "right",
          width: '150px',
          style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          render: (h, scope) => {
            return h('div', [
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  on: {
                    click: () => {
                      this.hometHandel(scope, 'details')
                    },
                  },
                },
                '详情'
              ),
              // h(
              //   'el-button',
              //   {
              //     props: { type: 'text', size: 'mini' },
              //     attrs: {
              //       disabled: scope.row.paymentState != 1 ? true : false,
              //     },
              //     on: {
              //       click: () => {
              //         this.reminderHandel(scope.row)
              //       },
              //     },
              //   },
              //   '提醒'
              // ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  attrs: {
                    disabled: (scope.row.paymentState == 2 || scope.row.paymentState == 8) ? false : true,
                  },
                  on: {
                    click: () => {
                      this.hometRefundHandel(scope.row)
                    },
                  },
                },
                scope.row.payAmount == 0 ? '' : scope.row.paymentState == 4 ? '已退款' : '退款'
              ),
            ])
          },
        },
      ],
      /**服务管理 */
      // serviceConfig: [
      //   {
      //     label: '序号',
      //     align: 'center',
      //     size: 'mini',
      //     render: (h, scope) => {
      //       return <span slot="reference">{scope.$index * 1 + 1}</span>
      //     },
      //   },
      //   { label: '服务开始时间', align: 'center', prop: 'name1', size: 'mini' },
      //   { label: '服务结束时间', align: 'center', prop: 'name2', size: 'mini' },
      //   {
      //     label: '操作',
      //     align: 'center',
      //     size: 'mini',
      //     render: (h, scope) => {
      //       return (
      //         <div>
      //           <el-button size="mini" type="text" onClick={() => this.hometHandel(scope, 'details')}>
      //             查看记录
      //           </el-button>
      //         </div>
      //       )
      //     },
      //   },
      // ],
      /**处方内容 */
      // prescriptionConfigL: [
      //   {
      //     label: '序号',
      //     align: 'center',
      //     fixed: 'left',
      //     size: 'mini',
      //     width: '50px',
      //     render: (h, scope) => {
      //       return <span slot="reference">{scope.$index * 1 + 1}</span>
      //     },
      //   },
      //   {
      //     label: '药品品名',
      //     align: 'center',
      //     prop: 'drugName',
      //     size: 'mini',
      //   },
      //   {
      //     label: '规格包装',
      //     align: 'center',
      //     prop: 'drugSpecification',
      //     size: 'mini',
      //   },
      //   {
      //     label: '生产商',
      //     align: 'center',
      //     prop: 'orderNo12',
      //     size: 'mini',
      //   },
      //   {
      //     label: '数量',
      //     align: 'center',
      //     prop: 'medicationNumber',
      //     size: 'mini',
      //   },
      //   {
      //     label: '单价',
      //     align: 'center',
      //     prop: 'drugPrice',
      //     size: 'mini',
      //     render: (h, scope) => {
      //       return <span slot="reference">{scope.row.drugPrice}/￥</span>
      //     },
      //   },
      // ],
    }
  },
}
